import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5428eb5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = ["name"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Прикрепить изображения", -1))
const _hoisted_4 = { class: "files grid" }
const _hoisted_5 = { alt: "" }
const _hoisted_6 = { class: "icon flex-center cursor" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cancel_icon = _resolveComponent("cancel-icon")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("span", null, _toDisplayString(_ctx.input.name), 1),
    _createElementVNode("label", _hoisted_1, [
      _createElementVNode("input", {
        type: "file",
        name: _ctx.input.id,
        ref: _ctx.input.id,
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('uploadFiles', { input: _ctx.input, ref: _ctx.$refs[_ctx.input.id] }))),
        multiple: ""
      }, null, 40, _hoisted_2),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "file",
          key: index
        }, [
          _withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [
            [_directive_lazy, file.src || _ctx.previewFileSrc(file)]
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_cancel_icon, {
              onClick: _withModifiers(($event: any) => (_ctx.deleteImage(file, index)), ["stop","prevent"])
            }, null, 8, ["onClick"])
          ])
        ]))
      }), 128))
    ])
  ]))
}